import { Dependencies } from "@planzone/core";

const cacheVersion = "45c337b5-cf1f-4079-9491-90a150d1fe02";

function createPreferencesRepository(): Dependencies["preferencesRepository"] {
  return {
    getPreferences() {
      const preferences = localStorage.getItem(`preferences:${cacheVersion}`);

      return Promise.resolve(!!preferences ? JSON.parse(preferences) : {});
    },
    updatePreferences(preferences) {
      localStorage.setItem(
        `preferences:${cacheVersion}`,
        JSON.stringify(preferences),
      );

      return Promise.resolve();
    },
  };
}

export { createPreferencesRepository };
